import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    SxSOptions,
} from 'owa-outlook-service-options';

export default function getSxSOptions(): SxSOptions {
    return getOptionsForFeature<SxSOptions>(OwsOptionsFeatureType.SxS);
}

export function getHideReadingPaneOption(): boolean {
    return getSxSOptions().hideReadingPane;
}
